import { render, staticRenderFns } from "./assessmentRecordLevel1Table.vue?vue&type=template&id=6bcf3b0c&scoped=true&"
import script from "./assessmentRecordLevel1Table.vue?vue&type=script&lang=js&"
export * from "./assessmentRecordLevel1Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf3b0c",
  null
  
)

export default component.exports